<template>
  <div v-on:click="change_status()">
    <span v-if="status == default_status" class="btn btn-xs btn-icon btn-light-success pulse pulse-success mr-5">
      <i class="flaticon2-protected"></i>
      <span class="pulse-ring"></span>
    </span>
    <span v-else class="btn btn-icon btn-xs btn-light-danger pulse pulse-danger mr-5">
      <i class="flaticon2-information"></i>
      <span class="pulse-ring"></span>
    </span>
  </div>
</template>
<script>
import {FARMER_SINGLE_UPDATED} from "@/core/services/store/farmer.module";

export default {
  name: 'status-change-self-capable',
  props: {
    status: {
      type: String
    },
    id: {
      type: Number
    }
  },

  data() {
    return {
      default_status: 'approved'
    };
  },
  methods: {
    async change_status() {
      if (!this.$props.status) {
        this.$props.status = this.default_status;
      } else {
        this.$props.status = null;
      }
      if (this.$props.id) {
        await this.$store.dispatch(FARMER_SINGLE_UPDATED, {
          status: this.$props.status,
          id: this.$props.id
        });
        this.$props.status = this.$store.getters.getSingleUpdatedFarmer.status;
        this.$props.id = this.$store.getters.getSingleUpdatedFarmer.id;
      }
    }
  }
}
</script>
